import React from 'react';
import { motion } from 'framer-motion';

const CTA = () => {
    return (
        <section className="py-40 px-6 max-w-7xl mx-auto text-center relative overflow-hidden">
            <motion.div
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                className="relative z-10 glass-card p-16 md:p-32 bg-blue-600 shadow-[0_40px_100px_rgba(37,99,235,0.2)]"
            >
                <h2 className="text-3xl md:text-5xl font-black leading-[1.1] text-white tracking-tighter mb-8">
                    READY TO REWIRE <br />
                    YOUR REALITY?
                </h2>
                <p className="text-base text-blue-100 mb-12 max-w-xl mx-auto font-medium opacity-80">
                    Join 10,000+ students who transformed their fear of mathematics into their greatest academic weapon.
                </p>
                <div className="flex flex-col sm:flex-row gap-6 justify-center">
                    <button className="px-16 py-7 bg-white text-[#0a0a0a] font-black text-sm rounded-[2rem] hover:scale-105 transition-all shadow-2xl uppercase tracking-widest">
                        Secure Your Slot
                    </button>
                    <button className="px-16 py-7 bg-transparent border-2 border-white/30 text-white font-black text-sm rounded-[2rem] hover:bg-white/10 transition-all uppercase tracking-widest">
                        Request Trial
                    </button>
                </div>
            </motion.div>
        </section>
    );
};

export default CTA;
